"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { HouseIcon, RefreshCcw, Smile } from "lucide-react";
import { Link } from "@/i18n/routing";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }; // digest — для прод-логов
  reset: () => void;
}) {
  useEffect(() => {
    // Логирование в Telegram, Sentry и т.п.
    const sendToTelegram = async () => {
      const message = `
🚨 <b>Ошибка в Dashboard</b>
<b>${error.name}</b>
<b>${error.message}</b>
<pre>${error.stack}</pre>
`;
      const encodedMsg = encodeURIComponent(message);
      fetch(
        `https://api.telegram.org/bot7506786216:AAE30KEWCELe7rdm48dPOkUyXbd182-_Jvw/sendMessage?chat_id=-4652360322&parse_mode=html&text=${encodedMsg}`
      )
        .then((res) => console.log(res))
        .catch((error) => console.error("Error:", error));
    };

    sendToTelegram();
  }, [error]);

  return (
    <div>
      <div className="flex flex-col items-center py-2 bg-white text-black ">
        <p className="text-xl">
          {" "}
          The service is undergoing some work. Don't worry, everything is fine.
          Try again later
        </p>{" "}
        <Smile />
      </div>
      <div className="flex justify-center gap-4 mt-6 items-center ">
        <Button>
          <Link className="flex items-center gap-4   font-bold" href={"/"}>
            <HouseIcon /> GO HOME
          </Link>
        </Button>
        <Button onClick={() => reset()}>
          Refresh <RefreshCcw />
        </Button>
      </div>
    </div>
  );
}
